import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../store/store";
import { IUser } from "../../models/IUser";
import { getDefaultRoute } from "../../utils/authorization";

interface ProtectedRouteProps {
  children: React.ReactNode;
  canAccess: (user: IUser | null) => boolean;
}

const ProtectedRoute = ({ children, canAccess }: ProtectedRouteProps) => {
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  if (!canAccess(currentUser)) {
    // Redirect to default route based on user role
    return <Navigate to={getDefaultRoute(currentUser)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;

